import { removeUserDevice } from '../clinicPortalServices/loginService';
import { goPatientLogin } from '../patientPortalServices/loginService';
import { isUserLoggedIn, getPatientAuthToken, getUserAuthToken } from './util';
import axios from 'axios';
import { serviceConstants } from './constants';

export const handleError = (error) => {
    if (error.status === 401) {
        if (isUserLoggedIn()) {
            if (error.message === 'Token has wrong Device ID') {
                window.localStorage.clear();
                window.location.href = '/';
            } else {
                removeUserDevice();
                window.location.href = '/';
            }
        } else if (getPatientAuthToken()) {
            goPatientLogin();
        } else {
            window.localStorage.clear();
            window.location.href = '/';
        }
    }
};

export const apiInterfaceForJson = (url, method, data, signal) => {
    let token = getUserAuthToken();
    if (!token) {
        token = getPatientAuthToken();
    }
    return axios
        .request({
            url: serviceConstants.API_HOST_NAME + url,
            method: method,
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + token
            },
            data: data,
            signal: signal
        })
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            console.error(`API Error on ${method} ${url}:`, error);
            if (error.response) {
                // For migration tool, return error data instead of redirecting
                if (url.includes('/migrationTool/')) {
                    return {
                        success: false,
                        message:
                            error.response.data?.message ||
                            error.response.data?.error ||
                            error.message ||
                            'An unknown error occurred',
                        error: error.response.data
                    };
                }
                handleError(error.response);
            } else if (error.request) {
                // Request was made but no response
                console.error('No response received:', error.request);
                return {
                    success: false,
                    message: 'No response from server. Please check your connection.',
                    error: error
                };
            } else {
                // Something else happened
                console.error('Request setup error:', error.message);
                return {
                    success: false,
                    message: error.message || 'Failed to make request',
                    error: error
                };
            }
        });
};

export const apiInterfaceForFormData = (url, method, formData) => {
    let token = getUserAuthToken();
    if (!token) {
        token = getPatientAuthToken();
    }
    return axios
        .request({
            url: serviceConstants.API_HOST_NAME + url,
            method: method,
            headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: 'Bearer ' + token
            },
            data: formData
        })
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            console.error(`API Error on ${method} ${url}:`, error);
            if (error.response) {
                // For migration tool, return error data instead of redirecting
                if (url.includes('/migrationTool/')) {
                    return {
                        success: false,
                        message:
                            error.response.data?.message ||
                            error.response.data?.error ||
                            error.message ||
                            'An unknown error occurred',
                        error: error.response.data
                    };
                }
                handleError(error.response);
            } else if (error.request) {
                // Request was made but no response
                console.error('No response received:', error.request);
                return {
                    success: false,
                    message: 'No response from server. Please check your connection.',
                    error: error
                };
            } else {
                // Something else happened
                console.error('Request setup error:', error.message);
                return {
                    success: false,
                    message: error.message || 'Failed to make request',
                    error: error
                };
            }
        });
};
